export function increaseCounterInName(name: string): string {
  // find iterator in the end of the name and increment it, if it exists, otherwise add ' 2' to the end of the name
  const regex = new RegExp('^(.*?)(\\s\\d+)?$');
  const match = name.match(regex);

  if (match) {
    const baseName = match[1];
    const iterator = match[2] ? parseInt(match[2].trim()) + 1 : 2;
    name = `${baseName} ${iterator}`;
  } else {
    name = `${name} 2`;
  }

  return name;
}
